import React from "react";
import { Tooltip, Whisper, Button } from "rsuite";
import FilterContext from "../../routes/FilterContext";
import { connect } from "react-redux";
// import { Icon } from "leaflet";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BodyAsFormData } from "../../services/utilities/util";
// import Plot from "react-plotly.js";
import {
  faArrowDown,
  faFilter,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import { Accordion } from "react-bootstrap";
import { apiMiddleware } from "../../services/apis/apiMiddleware";

import "react-pivottable/pivottable.css";
import PivotTable from "react-pivottable/PivotTable";
import createPlotlyRenderers from "react-pivottable/PlotlyRenderers";
import TableRenderers from "react-pivottable/TableRenderers";
import PivotTableUI from "react-pivottable/PivotTableUI";
import Alert from "react-bootstrap/Alert";
import { Icon } from "@iconify/react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { Slider, RangeSlider } from "rsuite";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  // Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import Plot from "react-plotly.js";
import Barchart from "../../muzeCharts/BarChart";

ChartJS.register(zoomPlugin);

// create Plotly React component via dependency injection

// create Plotly renderers via dependency injection
const PlotlyRenderers = createPlotlyRenderers(Plot);
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class MakeYourOwnChart extends React.Component {
  static contextType = FilterContext;
  minValue;
  maxValue;
  minLabel;
  maxLabel;

  constructor(props) {
    super(props);
    // this.onMove = this.onMove.bind(this);
    this.search_parameters = Object.keys(
      Object.assign({}, ...this.state.columnList)
    );
  }

  state = {
    myData: [],
    rows: [],
    columns: [],
    filters: [],
    values: [],
    columnList: [],
    columnWidgets: [],
    rowWidgets: [],
    filterWidgets: [],
    valueWidgets: [],
    searchQuery: "",
    updatedWidgetName: "",
    updatedWidgetLabel: "",
    dataLabelType: "",
    isSearchable: true,
    errMessage: "",
    show: false,
    modalShowColumn: false,
    modalShowFilter: false,
    selectedValue: "Sum",
    aggregateropDownValues: [
      {
        name: "sum",
        label: "Sum",
      },
      {
        name: "min",
        label: "Min",
      },
      {
        name: "max",
        label: "Max",
      },
      {
        name: "count",
        label: "Count",
      },
      {
        name: "average",
        label: "Average",
      },
      {
        name: "delete",
        label: "Delete",
      },
    ],
    filterSectionSearchable: [],
    selectedFilterSectionSearchable: [],
    filterSectionNotSearchable: [],
    selectedFilterSectionNotSearchable: [],
    filterSectionDate: [],
    selectedFilterSectionDate: [],
    filterSectionMinMax: [],
    selectedFilterSectionMinMax: [],
    stringNotSearchableDataCol: [],
    stringNotSearchableDataRow: [],
    selectedStringNotSearchableDataCol: [],
    selectedStringNotSearchableDataRow: [],
    stringSearchableDataColumn: [],
    stringSearchableDataRow: [],
    selectedStringSearchableDataCol: [],
    selectedStringSearchableDataRow: [],
    columnTypeNumberDataCol: [],
    columnTypeNumberDataRow: [],
    columnTypeDateDataCol: [],
    columnTypeDateDataRow: [],
    selectedColumnTypeDateDataCol: [],
    selectedColumnTypeDateDataRow: [],
    searchingData: "",
    yearlyOrQuarterlyCol: "y",
    yearlyOrQuarterlyRow: "y",
    yearlyOrQuarterlyFilter: "y",
    currentColumnValue: "",
    currentColumnType: "",
    currentColumnSearchable: "",
    currentColumnMode: "",
    currentRowValue: "",
    currentRowType: "",
    currentRowSearchable: "",
    currentRowMode: "",
    currentFilterValue: "",
    currentFilterType: "",
    currentFilterSearchable: "",
    currentFilterMode: "",
    updatedSelectedColumn: [],
    updatedSelectedRow: [],
    updatedSelectedFilter: [],
    popupIsIncludedCol: true,
    popupIsIncludedRow: true,
    popupIsIncludedFilter: true,
    excluded: [],
    selectedMinMaxValueColumn: [],
    selectedMinMaxValueRow: [],
    selectedMinMaxValueFilter: [],
    currentSelectedMinMaxColumnValue: [0, 100],
    currentSelectedMinMaxRowValue: [0, 100],
    currentSelectedMinMaxFilterValue: [0, 100],
    minValueColumn: 0,
    maxValueColumn: 0,
    minValueTextColumn: 0,
    maxValueTextColumn: 0,
    minValueRow: 0,
    maxValueRow: 0,
    minValueTextRow: 0,
    maxValueTextRow: 0,
    minValueFilter: 0,
    maxValueFilter: 0,
    minValueTextFilter: 0,
    maxValueTextFilter: 0,
    dataFormat: "Table",
    chartOtions: {},
    plotlyChartOptions: [],
    chartData: {
      labels: [],
      datasets: [],
    },
    chartStatistics: [],
    excludeNullEmptyCol: true,
    excludeNullEmptyColIndex: [],
    excludeNullEmptyRow: true,
    excludeNullEmptyRowIndex: [],
    // chartColName: [],
  };

  handleOnDrag = (e, displayName, diaplayLabel, labelType, searchable) => {
    e.dataTransfer.setData(
      "diaplayLabel",
      diaplayLabel,
      "widgetName",
      displayName
    );
    this.setState({
      updatedWidgetName: displayName,
      updatedWidgetLabel: diaplayLabel,
      dataLabelType: labelType,
      isSearchable: searchable,
    });
    // // // console.log(`Name is ${displayName} and Label is ${diaplayLabel} and type is ${labelType} and ${searchable}`);
  };

  addActiveClassToElement = (selector, diaplayLabel) => {
    const draggedLiElement = document.querySelectorAll(selector);
    draggedLiElement.forEach((val) => {
      if (val.textContent.trim() === diaplayLabel.trim()) {
        val.classList.add("active");
      }
    });
  };

  removeActiveClassFromElement = (selector, diaplayLabel) => {
    const draggedLiElement = document.querySelectorAll(selector);
    draggedLiElement.forEach((val) => {
      if (val.textContent.trim() === diaplayLabel.trim()) {
        val.classList.remove("active");
      }
    });
  };

  // Column Section
  handleOnDropColumn = (e) => {
    e.preventDefault();

    const displayName = this.state.updatedWidgetName;
    const diaplayLabel = this.state.updatedWidgetLabel;
    const columnType = this.state.dataLabelType;
    const isSearchable = this.state.isSearchable;
    const excludeNullEmptyCol = this.state.excludeNullEmptyCol;

    if (
      !this.state.columnWidgets.some(
        (widget) => widget.column_name === displayName
      )
    ) {
      this.addActiveClassToElement(".myocL ul li", diaplayLabel);

      const updatedWidgets = [
        ...this.state.columnWidgets,
        {
          column_name: displayName,
          display_name: diaplayLabel,
          column_type: columnType,
          searchable: isSearchable,
          checked: true,
          exclude_null_empty: excludeNullEmptyCol,
        },
      ];

      var columns = this.state.columns;
      columns.push(diaplayLabel);
      this.setState({ columns: columns });

      this.setState({ columnWidgets: updatedWidgets }, () => {
        this.fetchData();
        this.updateBarChartData();
        console.log(this.state.columnWidgets, "this.state.columnWidgets");
      });
    } else {
      this.setState({ show: true, errMessage: "Already Exist" });
      setTimeout(() => {
        this.setState({ show: false, errMessage: "" });
      }, 2000);
    }
  };
  handleColumnDelete = (column_name, display_name, column_type) => {
    const diaplayLabel = this.state.updatedWidgetLabel;
    const updatedWidgets = this.state.columnWidgets.filter(
      (widget) => widget.column_name !== column_name
    );
    const columnIndex = this.state.columns.indexOf(display_name);

    if (columnIndex !== -1) {
      const updatedColumns = [...this.state.columns];
      updatedColumns.splice(columnIndex, 1);

      this.setState({ columns: updatedColumns });
      this.fetchData();
    } else {
      // // console.log(`Column with display name ${display_name} not found.`);
    }

    if (column_name === this.state.currentColumnValue) {
      const _updatedSelectedColumn = { ...this.state.updatedSelectedColumn };
      _updatedSelectedColumn[column_name] = []; // Make it empty
      this.setState({ updatedSelectedColumn: _updatedSelectedColumn });
    }

    this.setState({ columnWidgets: updatedWidgets });
    this.removeActiveClassFromElement(".myocL ul li", display_name);
    this.fetchData();
    // // // console.log(
    //   this.state.updatedSelectedColumn,
    //   "this.state.updatedSelectedColumn"
    // );
  };
  handleModalShowColumn = (val, index) => {
    // console.log(val, "val");
    let tempPopupInclded;
    this.setState({ excludeNullEmptyCol: val.checked });
    if (this.state.excluded.indexOf(val.column_name) > -1) {
      tempPopupInclded = false;
    } else {
      tempPopupInclded = true;
    }
    var _tempCurrentSelectedValue = this.state.currentSelectedMinMaxColumnValue;
    if (this.state.selectedMinMaxValueColumn[val.column_name] != undefined) {
      _tempCurrentSelectedValue =
        this.state.selectedMinMaxValueColumn[val.column_name];
    }

    // console.log(this.state.columnWidgets, "this.state.columnWidgets");

    // let _tempNullEmpty = this.state.excludeNullEmpty

    this.setState(
      {
        currentColumnValue: val.column_name,
        currentColumnType: val.column_type,
        currentColumnSearchable: val.searchable,
        currentColumnMode: this.state.yearlyOrQuarterlyCol,
        selectedStringSearchableDataCol:
          this.state.updatedSelectedColumn[val.column_name],
        selectedStringNotSearchableDataCol:
          this.state.updatedSelectedColumn[val.column_name],
        selectedColumnTypeDateDataCol:
          this.state.updatedSelectedColumn[val.column_name],
        popupIsIncludedCol: tempPopupInclded,
        currentSelectedMinMaxColumnValue: _tempCurrentSelectedValue,
        excludeNullEmptyColIndex: index,
      },
      () => {
        if (
          (val.column_type === "string" && val.searchable === false) ||
          val.column_type === "date" ||
          ["number", "decimal1", "decimal2", "decimal4"].includes(
            val.column_type
          )
        ) {
          this.fetchFilterDataColumn();
        } else if (val.column_type === "string" && val.searchable === true) {
          this.fetchFilterDataOnSearchColumn();
        }
      }
    );

    this.setState({ modalShowColumn: true });
  };
  fetchFilterDataOnSearchColumn = () => {
    var filters = JSON.stringify({
      column_name: this.state.currentColumnValue,
      column_type: this.state.currentColumnType,
      searchable: this.state.currentColumnSearchable,
      search: this.state.searchingData,
      exclude_null_empty: this.state.excludeNullEmptyCol,
    });

    var body = new FormData();
    body.append("filter", filters);

    // if (this.state.searchingData.length < 1) {
    //   this.setState({ stringSearchableDataColumn: [] });
    //   return;
    // }
    // console.log(
    //   filters,
    //   "==",
    //   BodyAsFormData(filters),
    //   "fetchFilterDataOnSearchColumn"
    // );

    apiMiddleware
      .post(`api/edge/office/get_myoc_filter_data`, body)
      .then((data) => {
        this.setState({ stringSearchableDataColumn: data.data }, () => {
          // console.log(this.state.stringSearchableDataColumn);
        });
      });
  };
  fetchFilterDataColumn = () => {
    if (this.state.currentColumnType === "date") {
      var filters = JSON.stringify({
        column_name: this.state.currentColumnValue,
        column_type: this.state.currentColumnType,
        searchable: this.state.currentColumnSearchable,
        mode: this.state.yearlyOrQuarterlyCol,
        exclude_null_empty: this.state.excludeNullEmptyCol,
      });
    } else {
      var filters = JSON.stringify({
        column_name: this.state.currentColumnValue,
        column_type: this.state.currentColumnType,
        searchable: this.state.currentColumnSearchable,
        exclude_null_empty: this.state.excludeNullEmptyCol,
      });
    }
    var body = new FormData();
    body.append("filter", filters);

    // console.log(
    //   filters,
    //   "==",
    //   BodyAsFormData(filters),
    //   "fetchFilterDataColumn"
    // );

    apiMiddleware
      .post(`api/edge/office/get_myoc_filter_data`, body)
      .then((data) => {
        // // console.log(data.data, "Column Data");
        if (
          this.state.currentColumnType === "string" &&
          this.state.currentColumnSearchable === false
        ) {
          this.setState({ stringNotSearchableDataCol: data.data });
        }

        if (this.state.currentColumnType === "date") {
          this.setState({ columnTypeDateDataCol: data.data });
        }

        if (
          ["number", "decimal1", "decimal2", "decimal4"].includes(
            this.state.currentColumnType
          )
        ) {
          this.setState({ columnTypeNumberDataCol: data.data }, () => {
            const minValue = parseFloat(
              this.state.columnTypeNumberDataCol.find(
                (item) => item.label === "min"
              )?.value
            );
            const maxValue = parseFloat(
              this.state.columnTypeNumberDataCol.find(
                (item) => item.label === "max"
              )?.value
            );
            var tempSelectedMinMaxValueColumn =
              this.state.selectedMinMaxValueColumn;
            if (
              tempSelectedMinMaxValueColumn[this.state.currentColumnValue] ==
              undefined
            ) {
              this.setState({
                currentSelectedMinMaxColumnValue: [minValue, maxValue],
              });
            }
            tempSelectedMinMaxValueColumn[this.state.currentColumnValue] = [
              minValue,
              maxValue,
            ];

            this.setState(
              {
                minValueColumn: minValue,
                maxValueColumn: maxValue,
                minValueTextColumn: minValue,
                maxValueTextColumn: maxValue,
                selectedMinMaxValueColumn: tempSelectedMinMaxValueColumn,
              },
              () => {
                // console.log(this.state.minValueColumn);
                // console.log(this.state.maxValueColumn);
              }
            );
          });
        }
      });
  };
  // Column Section

  // Row Section
  handleOnDropRow = (e) => {
    e.preventDefault();

    const displayName = this.state.updatedWidgetName;
    const diaplayLabel = this.state.updatedWidgetLabel;
    const columnType = this.state.dataLabelType;
    const isSearchable = this.state.isSearchable;
    const excludeNullEmptyRow = this.state.excludeNullEmptyRow;

    if (
      !this.state.rowWidgets.some(
        (widget) => widget.column_name === displayName
      )
    ) {
      this.addActiveClassToElement(".myocL ul li", diaplayLabel);
      const updatedWidgets = [
        ...this.state.rowWidgets,
        {
          column_name: displayName,
          display_name: diaplayLabel,
          column_type: columnType,
          searchable: isSearchable,
          checked: true,
          exclude_null_empty: excludeNullEmptyRow,
        },
      ];

      var rows = this.state.rows;
      rows.push(diaplayLabel);
      this.setState({ rows: rows });

      this.setState({ rowWidgets: updatedWidgets }, () => {
        // console.log("rowWidgets", this.state.rowWidgets);
        this.fetchData();
        this.updateBarChartData();
      });
    } else {
      this.setState({ show: true, errMessage: "Already Exist" });
      setTimeout(() => {
        this.setState({ show: false, errMessage: "" });
      }, 2000);
    }
  };
  handleRowDelete = (column_name, display_name) => {
    const diaplayLabel = this.state.updatedWidgetLabel;
    const updatedWidgets = this.state.rowWidgets.filter(
      (widget) => widget.column_name !== column_name
    );

    const rowIndex = this.state.rows.indexOf(display_name);

    if (rowIndex !== -1) {
      const updatedRows = [...this.state.rows];
      updatedRows.splice(rowIndex, 1);

      this.setState({ rows: updatedRows });
      this.fetchData();
    } else {
      // // console.log(`Column with display name ${display_name} not found.`);
    }

    if (column_name === this.state.currentRowValue) {
      const _updatedSelectedRow = { ...this.state.updatedSelectedRow };
      _updatedSelectedRow[column_name] = []; // Make it empty
      this.setState({ updatedSelectedRow: _updatedSelectedRow });
    }

    this.setState({ rowWidgets: updatedWidgets });
    this.removeActiveClassFromElement(".myocL ul li", display_name);
    this.fetchData();
  };
  handleModalShowRow = (val, index) => {
    // console.log(val, "val");
    let tempPopupInclded;
    this.setState({ excludeNullEmptyRow: val.checked });
    if (this.state.excluded.indexOf(val.column_name) > -1) {
      tempPopupInclded = false;
    } else {
      tempPopupInclded = true;
    }
    var _tempCurrentSelectedValue = this.state.currentSelectedMinMaxRowValue;
    if (this.state.selectedMinMaxValueRow[val.column_name] != undefined) {
      _tempCurrentSelectedValue =
        this.state.selectedMinMaxValueRow[val.column_name];
    }
    this.setState(
      {
        currentRowValue: val.column_name,
        currentRowType: val.column_type,
        currentRowSearchable: val.searchable,
        currentRowMode: this.state.yearlyOrQuarterlyRow,
        selectedStringSearchableDataRow:
          this.state.updatedSelectedRow[val.column_name],
        selectedStringNotSearchableDataRow:
          this.state.updatedSelectedRow[val.column_name],
        selectedColumnTypeDateDataRow:
          this.state.updatedSelectedRow[val.column_name],
        popupIsIncludedRow: tempPopupInclded,
        currentSelectedMinMaxRowValue: _tempCurrentSelectedValue,
        excludeNullEmptyRowIndex: index,
      },
      () => {
        if (
          (val.column_type === "string" && val.searchable === false) ||
          val.column_type === "date" ||
          ["number", "decimal1", "decimal2", "decimal4"].includes(
            val.column_type
          )
        ) {
          this.fetchFilterDataRow();
        } else if (val.column_type === "string" && val.searchable === true) {
          this.fetchFilterDataOnSearchRow();
        }
      }
    );
    this.setState({ modalShowRow: true });
  };
  fetchFilterDataOnSearchRow = () => {
    var filters = JSON.stringify({
      column_name: this.state.currentRowValue,
      column_type: this.state.currentRowType,
      searchable: this.state.currentRowSearchable,
      search: this.state.searchingData,
      exclude_null_empty: this.state.excludeNullEmptyRow,
    });

    var body = new FormData();
    body.append("filter", filters);

    // if (this.state.searchingData.length < 1) {
    //   this.setState({ stringSearchableDataRow: [] });
    //   return;
    // }

    apiMiddleware
      .post(`api/edge/office/get_myoc_filter_data`, body)
      .then((data) => {
        this.setState({ stringSearchableDataRow: data.data }, () => {
          // console.log(this.state.stringSearchableDataRow);
        });
      });
  };
  fetchFilterDataRow = () => {
    if (this.state.currentRowType === "date") {
      var filters = JSON.stringify({
        column_name: this.state.currentRowValue,
        column_type: this.state.currentRowType,
        searchable: this.state.currentRowSearchable,
        mode: this.state.yearlyOrQuarterlyRow,
        exclude_null_empty: this.state.excludeNullEmptyRow,
      });
    } else {
      var filters = JSON.stringify({
        column_name: this.state.currentRowValue,
        column_type: this.state.currentRowType,
        searchable: this.state.currentRowSearchable,
        exclude_null_empty: this.state.excludeNullEmptyRow,
      });
    }
    var body = new FormData();
    body.append("filter", filters);

    // // console.log(filters, "==", BodyAsFormData(filters));

    apiMiddleware
      .post(`api/edge/office/get_myoc_filter_data`, body)
      .then((data) => {
        // // console.log(data.data, "Row Data");
        if (
          this.state.currentRowType === "string" &&
          this.state.currentRowSearchable === false
        ) {
          this.setState({ stringNotSearchableDataRow: data.data });
        }

        if (this.state.currentRowType === "date") {
          this.setState({ columnTypeDateDataRow: data.data });
        }

        if (
          ["number", "decimal1", "decimal2", "decimal4"].includes(
            this.state.currentRowType
          )
        ) {
          this.setState({ columnTypeNumberDataRow: data.data }, () => {
            const minValue = parseFloat(
              this.state.columnTypeNumberDataRow.find(
                (item) => item.label === "min"
              )?.value
            );
            const maxValue = parseFloat(
              this.state.columnTypeNumberDataRow.find(
                (item) => item.label === "max"
              )?.value
            );

            var tempSelectedMinMaxValueRow = this.state.selectedMinMaxValueRow;
            if (
              tempSelectedMinMaxValueRow[this.state.currentRowValue] ==
              undefined
            ) {
              this.setState({
                currentSelectedMinMaxRowValue: [minValue, maxValue],
              });
            }
            tempSelectedMinMaxValueRow[this.state.currentRowValue] = [
              minValue,
              maxValue,
            ];

            this.setState(
              {
                minValueRow: minValue,
                maxValueRow: maxValue,
                minValueTextRow: minValue,
                maxValueTextRow: maxValue,
                selectedMinMaxValueRow: tempSelectedMinMaxValueRow,
              },
              () => {
                // console.log(this.state.minValueRow);
                // console.log(this.state.maxValueRow);
              }
            );
          });
        }
      });
  };
  // Row Section

  // Filters Section
  handleOnDropFilters = (e) => {
    e.preventDefault();

    const displayName = this.state.updatedWidgetName;
    const diaplayLabel = this.state.updatedWidgetLabel;
    const columnType = this.state.dataLabelType;
    const isSearchable = this.state.isSearchable;

    if (
      !this.state.filterWidgets.some(
        (widget) => widget.column_name === displayName
      )
    ) {
      this.addActiveClassToElement(".myocL ul li", diaplayLabel);

      const updatedWidgets = [
        ...this.state.filterWidgets,
        {
          column_name: displayName,
          display_name: diaplayLabel,
          column_type: columnType,
          searchable: isSearchable,
          is_select: false,
        },
      ];

      var filterData = this.state.filters;
      filterData.push(diaplayLabel);
      this.setState({ filters: filterData });

      this.setState({ filterWidgets: updatedWidgets }, () => {
        // console.log(this.state.filterWidgets, "filterWidgets");
        this.fetchData();
      });
    } else {
      this.setState({ show: true, errMessage: "Already Exist" });
      setTimeout(() => {
        this.setState({ show: false, errMessage: "" });
      }, 2000);
    }
  };
  handleFilterDelete = (column_name, display_name, column_type) => {
    const diaplayLabel = this.state.updatedWidgetLabel;
    const updatedWidgets = this.state.filterWidgets.filter(
      (widget) => widget.column_name !== column_name
    );
    const filterIndex = this.state.filters.indexOf(display_name);

    if (filterIndex !== -1) {
      const updatedFilters = [...this.state.filters];
      updatedFilters.splice(filterIndex, 1);
      this.setState({ filters: updatedFilters });
      this.fetchData();
    }

    if (column_name === this.state.currentFilterValue) {
      const _updatedSelectedFilter = { ...this.state.updatedSelectedFilter };
      _updatedSelectedFilter[column_name] = []; // Make it empty
      this.setState({ updatedSelectedFilter: _updatedSelectedFilter });
    }

    this.setState({ filterWidgets: updatedWidgets }, () => {
      // console.log(this.state.filterWidgets, "filterWidgets");
    });
    this.removeActiveClassFromElement(".myocL ul li", display_name);
    this.fetchData();
  };
  handleModalShowFilters = (val) => {
    let tempPopupInclded;
    if (this.state.excluded.indexOf(val.column_name) > -1) {
      tempPopupInclded = false;
    } else {
      tempPopupInclded = true;
    }
    var _tempCurrentSelectedValue = this.state.currentSelectedMinMaxFilterValue;
    if (this.state.selectedMinMaxValueFilter[val.column_name] != undefined) {
      _tempCurrentSelectedValue =
        this.state.selectedMinMaxValueFilter[val.column_name];
    }
    this.setState(
      {
        currentFilterValue: val.column_name,
        currentFilterType: val.column_type,
        currentFilterSearchable: val.searchable,
        currentFilterMode: this.state.yearlyOrQuarterlyFilter,
        selectedFilterSectionNotSearchable:
          this.state.updatedSelectedFilter[val.column_name],
        selectedFilterSectionSearchable:
          this.state.updatedSelectedFilter[val.column_name],
        selectedFilterSectionDate:
          this.state.updatedSelectedFilter[val.column_name],
        currentSelectedMinMaxFilterValue: _tempCurrentSelectedValue,
        popupIsIncludedFilter: tempPopupInclded,
      },
      () => {
        if (
          (val.column_type === "string" && val.searchable === false) ||
          // (val.column_type === "string" && val.searchable === true) ||
          val.column_type === "date" ||
          ["number", "decimal1", "decimal2", "decimal4"].includes(
            val.column_type
          )
        ) {
          this.fetchFilterDataFilter();
        } else if (val.column_type === "string" && val.searchable === true) {
          this.fetchFilterDataOnSearchFilter();
        }
      }
    );
    this.setState({ modalShowFilter: true });
  };
  fetchFilterDataFilter = () => {
    if (this.state.currentFilterType === "date") {
      var filters = JSON.stringify({
        column_name: this.state.currentFilterValue,
        column_type: this.state.currentFilterType,
        searchable: this.state.currentFilterSearchable,
        mode: this.state.yearlyOrQuarterlyFilter,
      });
    } else {
      var filters = JSON.stringify({
        column_name: this.state.currentFilterValue,
        column_type: this.state.currentFilterType,
        searchable: this.state.currentFilterSearchable,
      });
    }
    var body = new FormData();
    body.append("filter", filters);

    // // console.log(filters, "==", BodyAsFormData(filters));

    apiMiddleware
      .post(`api/edge/office/get_myoc_filter_data`, body)
      .then((data) => {
        // // console.log(data.data, "Filter Data");
        if (
          this.state.currentFilterType === "string" &&
          this.state.currentFilterSearchable === false
        ) {
          this.setState({ filterSectionNotSearchable: data.data }, () => {
            // console.log(this.state.filterSectionNotSearchable);
          });
        }

        if (this.state.currentFilterType === "date") {
          this.setState({ filterSectionDate: data.data }, () => {
            // console.log(this.state.filterSectionDate);
          });
        }

        if (
          ["number", "decimal1", "decimal2", "decimal4"].includes(
            this.state.currentFilterType
          )
        ) {
          this.setState({ filterSectionMinMax: data.data }, () => {
            const minValue = parseFloat(
              this.state.filterSectionMinMax.find(
                (item) => item.label === "min"
              )?.value
            );
            const maxValue = parseFloat(
              this.state.filterSectionMinMax.find(
                (item) => item.label === "max"
              )?.value
            );

            var tempSelectedMinMaxValueFilter =
              this.state.selectedFilterSectionMinMax;
            if (
              tempSelectedMinMaxValueFilter[this.state.currentFilterValue] ==
              undefined
            ) {
              this.setState({
                currentSelectedMinMaxFilterValue: [minValue, maxValue],
              });
            }
            tempSelectedMinMaxValueFilter[this.state.currentFilterValue] = [
              minValue,
              maxValue,
            ];

            this.setState(
              {
                minValueFilter: minValue,
                maxValueFilter: maxValue,
                minValueTextFilter: minValue,
                maxValueTextFilter: maxValue,
                selectedFilterSectionMinMax: tempSelectedMinMaxValueFilter,
              },
              () => {
                // console.log(this.state.minValueFilter);
                // console.log(this.state.maxValueFilter);
              }
            );
          });
        }
      });
  };
  fetchFilterDataOnSearchFilter = () => {
    var filters = JSON.stringify({
      column_name: this.state.currentFilterValue,
      column_type: this.state.currentFilterType,
      searchable: this.state.currentFilterSearchable,
      search: this.state.searchingData,
    });

    var body = new FormData();
    body.append("filter", filters);

    // // console.log(filters, "==", BodyAsFormData(filters));

    // if (this.state.searchingData.length < 1) {
    //   this.setState({ stringSearchableDataFilter: [] });
    //   return;
    // }

    apiMiddleware
      .post(`api/edge/office/get_myoc_filter_data`, body)
      .then((data) => {
        this.setState({ filterSectionSearchable: data.data });
      });
  };
  // Filters Section

  handleOnDropValue = (e) => {
    e.preventDefault();

    const displayName = this.state.updatedWidgetName;
    const diaplayLabel = this.state.updatedWidgetLabel;

    if (
      !this.state.valueWidgets.some(
        (widget) => widget.column_name === displayName
      )
    ) {
      if (
        this.state.dataLabelType === "number" ||
        this.state.dataLabelType === "decimal2"
      ) {
        this.addActiveClassToElement(".myocL ul li", diaplayLabel);
      }
      const updatedWidgets = [
        ...this.state.valueWidgets,
        {
          column_name: displayName,
          display_name: diaplayLabel,
          aggregate: "sum",
          column_type: this.state.dataLabelType,
        },
      ];
      // var values = this.state.values;
      // values.push(diaplayLabel);
      // this.setState({values:values})
      if (
        this.state.dataLabelType === "number" ||
        this.state.dataLabelType === "decimal2"
      ) {
        this.setState({ valueWidgets: updatedWidgets }, () => {
          if (updatedWidgets.length > 1 && updatedWidgets.length <= 2) {
            var rows = this.state.rows;
            if (!rows.includes("column")) {
              rows.unshift("column");
              this.setState({ rows: rows });
            }
          } else if (updatedWidgets.length < 2) {
            var rows = this.state.rows;
            var columnIndex = rows.indexOf("column");
            if (columnIndex >= 0) {
              rows.splice(columnIndex, 1); // Remove "column"
              this.setState({ rows: rows });
            }
          } else if (updatedWidgets.length > 2) {
            var rows = this.state.rows;
            if (!rows.includes("column")) {
              rows.unshift("column");
              this.setState({ rows: rows });
            }
          }
          // console.log(this.state.valueWidgets, "valueWidgets");
          this.fetchData();
        });
      } else {
        this.setState({ show: true, errMessage: "Strings not allowed" });
        setTimeout(() => {
          this.setState({ show: false, errMessage: "" });
        }, 2000);
      }
    } else {
      this.setState({ show: true, errMessage: "Already Exist" });
      setTimeout(() => {
        this.setState({ show: false, errMessage: "" });
      }, 2000);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
  };

  handleValueDelete = (column_name, display_name) => {
    const diaplayLabel = this.state.updatedWidgetLabel;
    const updatedWidgets = this.state.valueWidgets.filter(
      (widget) => widget.column_name !== column_name
    );

    this.removeActiveClassFromElement(".myocL ul li", display_name);
    this.setState({ valueWidgets: updatedWidgets }, () => {
      if (updatedWidgets.length < 2) {
        var rows = this.state.rows;
        var columnIndex = rows.indexOf("column");
        if (columnIndex >= 0) {
          rows.splice(columnIndex, 1);
          this.setState({ rows: rows });
        }
      }
    });
    this.fetchData();
  };

  componentDidMount() {
    apiMiddleware.get("api/edge/office/get_db_columns_for_myoc").then((res) => {
      this.setState({ columnList: res.data });
      // // console.log(this.state.columnList);
    });
  }

  updateBarChartData = () => {
    // Bar Chart Code
    // if (
    //   this.state.columnWidgets.length > 0 &&
    //   // this.state.rowWidgets.length > 0 &&
    //   this.state.valueWidgets.length > 0
    // ) {
    //   // console.log(this.state.myData, "Mydata")
    //   // let x1 = this.state.myData.map(a => a["Micro Market"].substr(0, 3));
    //   let x1 = this.state.myData.map((a) =>
    //     a[this.state.columnWidgets[0].display_name].substr(0, 5)
    //   );
    //   let x2 = this.state.myData.map((a) =>
    //     a[this.state.rowWidgets[0].display_name].substr(0, 5)
    //   );
    //   let y = this.state.myData.map((a) => a["value"]);

    //   this.setState({
    //     plotlyChartOptions: [
    //       {
    //         x: [x2, x1],
    //         y: y,
    //         type: "bar",
    //         marker: { color: "#69cbfa" },
    //       },
    //     ],
    //   });
    // }
    //   this.setState({
    //     plotlyChartOptions: [
    //       {
    //         x: [x2, x1],
    //         y: y,
    //         type: "bar",
    //         marker: { color: "#69cbfa" },
    //       },
    //     ],
    //   });
    // }
  };

  fetchData() {
    if (
      (this.state.columnWidgets.length > 0 &&
        this.state.valueWidgets.length > 0) ||
      (this.state.rowWidgets.length > 0 &&
        this.state.valueWidgets.length > 0) ||
      (this.state.columnWidgets.length > 0 &&
        this.state.rowWidgets.length > 0 &&
        this.state.valueWidgets.length > 0)
    ) {
      let mergedColumnAndFilterData = [
        ...this.state.columnWidgets,
        ...this.state.filterWidgets,
      ];
      var myoc_filters = JSON.stringify({
        rows: this.state.rowWidgets,
        columns: mergedColumnAndFilterData,
        values: this.state.valueWidgets,
      });

      var body = new FormData();

      body.append("myoc_filters", myoc_filters);
      apiMiddleware.post("api/edge/office/get_myoc_data", body).then((res) => {
        if (res.error != undefined) return;
        // // console.log(res.data, "fetchData");
        this.setState({ myData: res.data }, () => {
          // console.log("this.state.myData", this.state.myData);
          let dataValue = this.state.myData.map((res) => res.value);
          this.setState({ chartStatistics: dataValue }, () => {
            this.updateBarChartData();
          });
        });
      });
    }
  }

  search(data) {
    return data.filter((item) =>
      item.column_label
        .toLowerCase()
        .includes(this.state.searchQuery.toLowerCase())
    );
  }

  componentDidUpdate() {}

  createTable() {
    if (this.state.myData.length == 0) {
      return;
    }
    let rowHeaders = [];
    let columnHeaders = [];
    let processedData = [];
    // // console.log(this.state.myData);
    for (let i = 0; i < this.state.myData.length; i++) {
      for (let j = 0; j < this.state.columns.length; j++) {
        if (columnHeaders[this.state.columns[j]] == undefined) {
          columnHeaders[this.state.columns[j]] = [];
        }
        if (
          columnHeaders[this.state.columns[j]].indexOf(
            this.state.myData[i][this.state.columns[j]]
          ) == -1
        )
          columnHeaders[this.state.columns[j]].push(
            this.state.myData[i][this.state.columns[j]]
          );
      }

      for (let j = 0; j < this.state.rows.length; j++) {
        if (rowHeaders[this.state.rows[j]] == undefined) {
          rowHeaders[this.state.rows[j]] = [];
        }
        //// // console.log(rowHeaders[this.state.columns[j]].indexOf(this.state.myData[i][this.state.columns[j]]));
        if (
          rowHeaders[this.state.rows[j]].indexOf(
            this.state.myData[i][this.state.rows[j]]
          ) == -1
        )
          rowHeaders[this.state.rows[j]].push(
            this.state.myData[i][this.state.rows[j]]
          );
      }
    }
    var totalColumns = 1;
    var totalRows = 1;
    // // console.log(rowHeaders);
    // // console.log(columnHeaders);
    var colspan = 1;
    for (let key in columnHeaders) {
      // // console.log(key, columnHeaders[key]);
      totalColumns = totalColumns * columnHeaders[key].length;
    }

    for (let key in rowHeaders) {
      // // console.log(key, rowHeaders[key]);
      totalRows = totalRows * rowHeaders[key].length;
    }
    var i = 0;
    var colspan = 1;

    var coloumnHeaderProcessed = [];
    for (let key in columnHeaders) {
      var totalLength = columnHeaders[key].length;
      if (i != 0) {
        //colspan =
      }
      var repeats = totalColumns / (columnHeaders[key].length * colspan);
      coloumnHeaderProcessed[i] = [];
      coloumnHeaderProcessed[i]["colspan"] = colspan;
      coloumnHeaderProcessed[i]["repeat"] = repeats;
      coloumnHeaderProcessed[i]["key"] = key;
      colspan = columnHeaders[key].length * colspan;
      i++;
    }
    var headerTable = [];
    for (i = coloumnHeaderProcessed.length - 1; i >= 0; i--) {
      var td = [];
      for (let k = 0; k < this.state.rows.length; k++) {
        td.push(<td></td>);
      }
      //headerTable.push(<tr>
      for (let j = 0; j < coloumnHeaderProcessed[i]["repeat"]; j++) {
        td.push(
          columnHeaders[coloumnHeaderProcessed[i]["key"]].map((el, idx) => (
            <td
              colspan={coloumnHeaderProcessed[i]["colspan"]}
              style={{ border: "1px solid" }}
            >
              {el}
            </td>
          ))
        );
      }
      headerTable.push(<tr>{td}</tr>);
    }

    var i = 0;
    var rowspan = 1;

    var rowHeaderProcessed = [];
    for (let key in rowHeaders) {
      var totalLength = rowHeaders[key].length;
      if (i != 0) {
        //colspan =
      }
      var repeats = totalRows / (rowHeaders[key].length * rowspan);
      rowHeaderProcessed[i] = [];
      rowHeaderProcessed[i]["rowspan"] = rowspan;
      rowHeaderProcessed[i]["repeat"] = repeats;
      rowHeaderProcessed[i]["key"] = key;
      rowspan = rowHeaders[key].length * rowspan;
      i++;
    }
    var noColumnHeader = [];

    for (var j = rowHeaderProcessed.length - 1; j >= 0; j--) {
      noColumnHeader.push(0);
    }
    var rowHeaderAtArray = [];
    for (i = 0; i < 5; i++) {
      var td = [];

      for (var j = rowHeaderProcessed.length - 1; j >= 0; j--) {
        if (rowHeaderAtArray[j] == undefined) {
          rowHeaderAtArray[j] = 0;
        }

        if (noColumnHeader[j] != 0) {
          noColumnHeader[j]--;
          continue;
        }

        if (noColumnHeader[j] == 0) {
          noColumnHeader[j] = rowHeaderProcessed[j]["rowspan"] - 1;
        } else {
          noColumnHeader[j]--;
        }
        // // console.log(j);

        td.push(
          <td rowspan={rowHeaderProcessed[j]["rowspan"]}>
            {
              rowHeaders[rowHeaderProcessed[j]["key"]][
                rowHeaderAtArray[j] %
                  rowHeaders[rowHeaderProcessed[j]["key"]].length
              ]
            }
          </td>
        );
        rowHeaderAtArray[j]++;
        // td.push(rowHeaders[rowHeaderProcessed[j]['key']].map((el, idx) => (
        //   <td rowspan={rowHeaderProcessed[j]['rowspan']} style={{border:"1px solid"}}>y</td>
        // )))
      }
      headerTable.push(<tr>{td}</tr>);
    }
    //return (123)
    // // console.log(coloumnHeaderProcessed);
    // // console.log(rowHeaderProcessed);
    return <table border={1}>{headerTable}</table>;
    //// // console.log(coloumnHeaderProcessed);
    //let temp = [];
    // for(let i=0;i<this.state.myData.length;i++) {
    //   let temp = [];

    //   for(let j=0; j< this.state.columns.length;j++) {
    //     //if(temp[this.state.columns[j]]==undefined)
    //     var a =[];
    //     // // console.log(this.state.columns[j]);

    //     a[this.state.myData[i][this.state.columns[j]]] = [];
    //     a[this.state.myData[i][this.state.columns[j]]]['data'] = temp;
    //     //temp = temp[this.state.columns[j]];
    //     temp = a;

    //     //break;
    //   }
    //   processedData.push(temp);
    // }

    //// // console.log("row",rowHeaders);
    //// // console.log(columnHeaders);
    return JSON.stringify(columnHeaders);
  }

  cellData(data, rowKey, colKey) {
    // // console.log(data);

    return {
      count: 0,
      push: function (record) {
        // // console.log(record);
        this.count++;
      },
      value: function () {
        return this.count;
      },
      format: function (x) {
        return x;
      },
    };
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  handleDropdownChange = (val, index) => {
    // // console.log(index);
    var _tempValues = this.state.valueWidgets;
    // // console.log(_tempValues);
    _tempValues[index]["aggregate"] = val;
    this.setState({ valueWidgets: _tempValues });
    this.fetchData();
  };

  handleRadioChangeCol = (value) => {
    this.setState({ yearlyOrQuarterlyCol: value }, () => {
      this.fetchFilterDataColumn();
    });
  };

  handleRadioChangeFilter = (value) => {
    this.setState({ yearlyOrQuarterlyFilter: value }, () => {
      this.fetchFilterDataFilter();
    });
  };

  handleRadioChangeRow = (value) => {
    this.setState({ yearlyOrQuarterlyRow: value }, () => {
      // this.setState({
      //   selectedColumnTypeDateData: [],
      // });
      this.fetchFilterDataRow();
    });
  };

  handleModalCloseCol = () => {
    this.setState({
      modalShowColumn: false,
      selectedStringSearchableDataCol: [],
      selectedColumnTypeDateDataCol: [],
    });
  };

  handleModalCloseRow = () => {
    this.setState({
      modalShowRow: false,
      selectedStringSearchableDataRow: [],
      selectedColumnTypeDateDataRow: [],
    });
  };

  handleModalCloseFilter = () => {
    this.setState({
      modalShowFilter: false,
      selectedFilterSectionNotSearchable: [],
      selectedFilterSectionDate: [],
    });
  };

  updateTableDataForColumn = (selectedData) => {
    let tempExcluded = this.state.excluded;
    if (!this.state.popupIsIncludedCol) {
      if (tempExcluded.indexOf(this.state.currentColumnValue) === -1) {
        tempExcluded.push(this.state.currentColumnValue);
      }
    } else {
      const index = tempExcluded.indexOf(this.state.currentColumnValue);
      if (index > -1) {
        tempExcluded.splice(index, 1);
      }
    }

    // const updatedData = [...selectedData];
    const updatedData = Array.isArray(selectedData) ? selectedData : [];
    var _updatedSelectedColumn = this.state.updatedSelectedColumn;
    _updatedSelectedColumn[this.state.currentColumnValue] = updatedData;

    this.setState({
      modalShowColumn: false,
      updatedSelectedColumn: _updatedSelectedColumn,
    });

    let updatedDataValue = [];

    updatedData.map((val) => {
      updatedDataValue = [...updatedDataValue, val.value];
    });

    let presentColumnValue = this.state.columnWidgets.find(
      (o) => o.column_name.trim() === this.state.currentColumnValue.trim()
    );
    // console.log(presentColumnValue, "gscsiucuiwbui");

    if (this.state.popupIsIncludedCol) {
      presentColumnValue.in = updatedDataValue;
      delete presentColumnValue.not_in;
    } else {
      presentColumnValue.not_in = updatedDataValue;
      delete presentColumnValue.in;
    }

    var indexOfpresentColumnValue = this.state.columnWidgets.findIndex(
      (i) => i.column_name.trim() === this.state.currentColumnValue.trim()
    );
    // console.log(indexOfpresentColumnValue, "Hello");

    var tempColWidget = this.state.columnWidgets;
    tempColWidget[indexOfpresentColumnValue] = presentColumnValue;

    this.setState({ columnWidgets: tempColWidget }, () => {
      this.fetchData();
    });
  };

  updateTableDataForDateCol = () => {
    this.updateTableDataForColumn(this.state.selectedColumnTypeDateDataCol);
  };

  updateTableDataForNonSearchStringCol = () => {
    this.updateTableDataForColumn(
      this.state.selectedStringNotSearchableDataCol
    );
  };

  selectedStringSearchableDataColBtn = () => {
    this.updateTableDataForColumn(this.state.selectedStringSearchableDataCol);
  };

  updateTableDataForRow = (selectedData) => {
    let tempExcluded = this.state.excluded;
    if (!this.state.popupIsIncludedRow) {
      if (tempExcluded.indexOf(this.state.currentRowValue) === -1) {
        tempExcluded.push(this.state.currentRowValue);
      }
    } else {
      const index = tempExcluded.indexOf(this.state.currentRowValue);
      if (index > -1) {
        tempExcluded.splice(index, 1);
      }
    }

    // const updatedData = [...selectedData];
    const updatedData = Array.isArray(selectedData) ? selectedData : [];
    var _updatedSelectedRow = { ...this.state.updatedSelectedRow };
    _updatedSelectedRow[this.state.currentRowValue] = updatedData;

    this.setState({
      modalShowRow: false,
      updatedSelectedRow: _updatedSelectedRow,
    });

    let updatedDataValue = [];

    updatedData.map((val) => {
      updatedDataValue = [...updatedDataValue, val.value];
    });

    let presentRowValue = this.state.rowWidgets.find(
      (o) => o.column_name.trim() === this.state.currentRowValue.trim()
    );
    // console.log(presentRowValue, "gscsiucuiwbui");

    if (this.state.popupIsIncludedRow) {
      presentRowValue.in = updatedDataValue;
      delete presentRowValue.not_in;
    } else {
      presentRowValue.not_in = updatedDataValue;
      delete presentRowValue.in;
    }

    var indexOfpresentRowValue = this.state.rowWidgets.findIndex(
      (i) => i.column_name.trim() === this.state.currentRowValue.trim()
    );
    // console.log(indexOfpresentRowValue, "Hello");

    var tempRowWidget = this.state.rowWidgets;
    tempRowWidget[indexOfpresentRowValue] = presentRowValue;

    this.setState({ rowWidgets: tempRowWidget }, () => {
      this.fetchData();
    });
  };

  updateTableDataForDateRow = () => {
    this.updateTableDataForRow(this.state.selectedColumnTypeDateDataRow);
  };

  updateTableDataForNonSearchStringRow = () => {
    this.updateTableDataForRow(this.state.selectedStringNotSearchableDataRow);
  };

  updateTableDataRow = () => {
    this.updateTableDataForRow(this.state.selectedStringSearchableDataRow);
  };

  filterSectionFunction = (selectedData) => {
    let tempExcluded = this.state.excluded;
    if (!this.state.popupIsIncludedFilter) {
      if (tempExcluded.indexOf(this.state.currentFilterValue) === -1) {
        tempExcluded.push(this.state.currentFilterValue);
      }
    } else {
      const index = tempExcluded.indexOf(this.state.currentFilterValue);
      if (index > -1) {
        tempExcluded.splice(index, 1);
      }
    }

    // const updatedData = [...selectedData];
    const updatedData = Array.isArray(selectedData) ? selectedData : [];
    var _updatedSelectedFilter = { ...this.state.updatedSelectedFilter };
    _updatedSelectedFilter[this.state.currentFilterValue] = updatedData;

    this.setState({
      modalShowFilter: false,
      updatedSelectedFilter: _updatedSelectedFilter,
    });

    let updatedDataValue = [];

    updatedData.map((val) => {
      updatedDataValue = [...updatedDataValue, val.value];
    });

    let presentFilterValue = this.state.filterWidgets.find(
      (o) => o.column_name.trim() === this.state.currentFilterValue.trim()
    );
    // console.log(presentFilterValue, "gscsiucuiwbui");

    if (this.state.popupIsIncludedFilter) {
      presentFilterValue.in = updatedDataValue;
      delete presentFilterValue.not_in;
    } else {
      presentFilterValue.not_in = updatedDataValue;
      delete presentFilterValue.in;
    }

    var indexOfpresentFilterValue = this.state.filterWidgets.findIndex(
      (i) => i.column_name.trim() === this.state.currentFilterValue.trim()
    );
    // console.log(indexOfpresentFilterValue, "Hello");

    var tempFilterWidget = this.state.filterWidgets;
    tempFilterWidget[indexOfpresentFilterValue] = presentFilterValue;

    this.setState({ filterWidgets: tempFilterWidget }, () => {
      this.fetchData();
    });
  };

  filterSectionNotSearchableBtn = () => {
    this.filterSectionFunction(this.state.selectedFilterSectionNotSearchable);
  };

  selectedFilterSectionSearchableBtn = () => {
    this.filterSectionFunction(this.state.selectedFilterSectionSearchable);
  };

  filterSectionDateBtn = () => {
    this.filterSectionFunction(this.state.selectedFilterSectionDate);
  };

  handleSelectChange = (selectedOptions, stateKey) => {
    this.setState({
      [stateKey]: selectedOptions,
    });
  };

  updateMinMaxDataColumn = () => {
    const { minValueTextColumn, maxValueTextColumn } = this.state;

    const updatedData = [minValueTextColumn, maxValueTextColumn];

    let presentColumnValue = this.state.columnWidgets.find(
      (o) => o.column_name.trim() === this.state.currentColumnValue.trim()
    );
    // console.log(presentColumnValue, "gscsiucuiwbui");

    presentColumnValue.start = minValueTextColumn;
    presentColumnValue.column_type = "number";
    presentColumnValue.end = maxValueTextColumn;
    var indexOfpresentColumnValue = this.state.columnWidgets.findIndex(
      (i) => i.column_name.trim() === this.state.currentColumnValue.trim()
    );
    // console.log(indexOfpresentColumnValue, "Hello");

    var tempColWidget = this.state.columnWidgets;
    tempColWidget[indexOfpresentColumnValue] = presentColumnValue;

    this.setState(
      { columnWidgets: tempColWidget, modalShowColumn: false },
      () => {
        this.fetchData();
      }
    );
  };

  updateMinMaxDataRow = () => {
    const { minValueTextRow, maxValueTextRow } = this.state;

    const updatedData = [minValueTextRow, maxValueTextRow];

    let presentRowValue = this.state.rowWidgets.find(
      (o) => o.column_name.trim() === this.state.currentRowValue.trim()
    );
    // console.log(presentRowValue, "gscsiucuiwbui");

    presentRowValue.start = minValueTextRow;
    presentRowValue.column_type = "number";
    presentRowValue.end = maxValueTextRow;
    var indexOfpresentRowValue = this.state.rowWidgets.findIndex(
      (i) => i.column_name.trim() === this.state.currentRowValue.trim()
    );
    // console.log(indexOfpresentRowValue, "Hello");

    var tempRowWidget = this.state.rowWidgets;
    tempRowWidget[indexOfpresentRowValue] = presentRowValue;

    this.setState({ rowWidgets: tempRowWidget, modalShowRow: false }, () => {
      this.fetchData();
    });
  };

  minMaxValueFilterBtn = () => {
    const { minValueTextFilter, maxValueTextFilter } = this.state;

    const updatedData = [minValueTextFilter, maxValueTextFilter];

    let presentFilterValue = this.state.filterWidgets.find(
      (o) => o.column_name.trim() === this.state.currentFilterValue.trim()
    );
    // console.log(presentFilterValue, "gscsiucuiwbui");

    presentFilterValue.start = minValueTextFilter;
    presentFilterValue.column_type = "number";
    presentFilterValue.end = maxValueTextFilter;
    var indexOfpresentFilterValue = this.state.filterWidgets.findIndex(
      (i) => i.column_name.trim() === this.state.currentFilterValue.trim()
    );
    // console.log(indexOfpresentFilterValue, "Hello");

    var tempFilterWidget = this.state.filterWidgets;
    tempFilterWidget[indexOfpresentFilterValue] = presentFilterValue;

    this.setState(
      { filterWidgets: tempFilterWidget, modalShowFilter: false },
      () => {
        this.fetchData();
      }
    );
  };

  handleDataFormat = (val) => {
    this.setState({ dataFormat: val });
  };

  toggleExcludeNullEmptyCol = () => {
    let xyz =
      !this.state.columnWidgets[this.state.excludeNullEmptyColIndex].checked;
    this.state.columnWidgets[this.state.excludeNullEmptyColIndex].checked = xyz;
    this.setState({ columnWidgets: [...this.state.columnWidgets] }, () => {
      this.setState({ excludeNullEmptyCol: xyz });
    });
  };

  toggleExcludeNullEmptyRow = () => {
    let xyz =
      !this.state.rowWidgets[this.state.excludeNullEmptyRowIndex].checked;
    this.state.rowWidgets[this.state.excludeNullEmptyRowIndex].checked = xyz;
    this.setState({ rowWidgets: [...this.state.rowWidgets] }, () => {
      this.setState({ excludeNullEmptyRow: xyz });
    });
  };

  render() {
    return (
      <>
        <div className="myocMain">
          <div className="myocL">
            <div className="myocLSearchArea d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-between align-items-center myocLSearchAreaL">
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) =>
                    this.setState({ searchQuery: e.target.value })
                  }
                />
                <Dropdown>
                  <Dropdown.Toggle variant="success">
                    <FontAwesomeIcon icon={faFilter} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>Filter</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <Dropdown className="noArrow">
                <Dropdown.Toggle variant="success">
                  <FontAwesomeIcon icon={faSortDown} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Filter</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <ul className="m-0 p-0">
              {this.search(this.state.columnList).map((res, index) => {
                return (
                  <Whisper
                    followCursor
                    placement="top"
                    speaker={<Tooltip>{res.column_label}</Tooltip>}
                  >
                    <li
                      key={index}
                      draggable
                      onDragStart={(e) =>
                        this.handleOnDrag(
                          e,
                          res.column_name,
                          res.column_label,
                          res.column_type,
                          res.searchable
                        )
                      }
                    >
                      {res.column_type === "string" ? (
                        <Icon icon="material-symbols:abc-rounded" />
                      ) : res.column_type === "date" ? (
                        <Icon icon="clarity:date-line" />
                      ) : (
                        <Icon icon="ant-design:number-outlined" />
                      )}{" "}
                      {res.column_label}
                    </li>
                  </Whisper>
                );
              })}
            </ul>
          </div>

          <div className="myocR">
            <div
              className="onDataDrop onDataDropGridView mb-2"
              onDrop={this.handleOnDropColumn}
              onDragOver={this.handleDragOver}
            >
              <div className="d-flex align-items-center iconWithLabel">
                <Icon icon="tdesign:view-column" />
                <p>Column</p>
              </div>
              <div className="d-flex align-items-center flexWithGap">
                {this.state.columnWidgets.map((val, index) => {
                  return (
                    <>
                      <Dropdown>
                        <Dropdown.Toggle variant="success">
                          {val.display_name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={(e) => {
                              this.handleModalShowColumn(val, index);
                            }}
                          >
                            Filter
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              this.handleColumnDelete(
                                val.column_name,
                                val.display_name,
                                val.column_type
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </>
                  );
                })}
              </div>
            </div>

            <div
              className="onDataDrop onDataDropGridView onDataDropRows mb-4"
              onDrop={this.handleOnDropRow}
              onDragOver={this.handleDragOver}
            >
              <div className="d-flex align-items-center iconWithLabel">
                <Icon icon="tdesign:view-column" rotate={1} />
                <p>Rows</p>
              </div>
              <div className="d-flex align-items-center flexWithGap">
                {this.state.rowWidgets.map((val, index) => {
                  return (
                    <>
                      <Dropdown>
                        <Dropdown.Toggle variant="success">
                          {val.display_name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={(e) => {
                              this.handleModalShowRow(val, index);
                            }}
                          >
                            Filter
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              this.handleRowDelete(
                                val.column_name,
                                val.display_name
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </>
                  );
                })}
              </div>
            </div>

            {/* <div className="row mx-0 tableTitle">
              <div className="col-6 p-0">
                <p>Chart 1 - Area Analysis</p>
              </div>
              <div className="col-6 p-0">
                <h4>Sector/Building Category/Landlord</h4>
              </div>
            </div> */}

            <div className="dragAndDropBox position-relative">
              {this.state.show ? (
                <Alert variant="danger" onClose={this.handleClose} dismissible>
                  <p>{this.state.errMessage}</p>
                </Alert>
              ) : (
                ""
              )}
              <div className="table-responsive">
                {
                  this.state.dataFormat === "Table" ? (
                    this.state.myData.length > 0 && (
                      <PivotTable
                        aggregatorName="Sum"
                        // rendererName="Table"
                        cols={this.state.columns}
                        rows={this.state.rows}
                        vals={["value"]}
                        //aggregators= {this.cellData(["area"])}
                        // data={
                        //   [
                        //     {sector:"a", tenant:"b", city:"c", area:15},
                        //     {sector:"a", tenant:"b", city:"z", area:15},
                        //     {sector:"x", tenant:"b", city:"z", area:15}
                        //   ]
                        // }
                        data={this.state.myData}
                        onChange={(s) => this.setState(s)}
                        renderers={Object.assign(
                          {},
                          TableRenderers,
                          PlotlyRenderers
                        )}

                        // {...this.state}
                      />
                    )
                  ) : (
                    // this.state.myData.length > 0 && (
                    // <Bar
                    //   options={this.state.chartOtions}
                    //   data={this.state.chartData}
                    // />
                    <Barchart chartData={{data:this.state.myData, cols:this.state.columnWidgets, rows:this.state.rowWidgets}} />
                  )
                  // )
                }
              </div>
            </div>
          </div>

          <div className="myocM">
            <Accordion defaultActiveKey="2">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Filters</Accordion.Header>
                <Accordion.Body>
                  <ul
                    className="p-0 m-0 valuesDrageedItem"
                    onDrop={this.handleOnDropFilters}
                    onDragOver={this.handleDragOver}
                  >
                    {this.state.filterWidgets.length > 0 ? null : (
                      <li>Drag and Drop Here</li>
                    )}
                    {this.state.filterWidgets.map((val, index) => {
                      return (
                        <>
                          <Dropdown>
                            <Dropdown.Toggle variant="success">
                              {val.display_name}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={(e) => {
                                  this.handleModalShowFilters(val);
                                }}
                              >
                                Filter
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() =>
                                  this.handleFilterDelete(
                                    val.column_name,
                                    val.display_name,
                                    val.column_type
                                  )
                                }
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </>
                      );
                    })}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Chart Type</Accordion.Header>
                <Accordion.Body>
                  <ul className="p-0 m-0">
                    <li
                      className={
                        this.state.dataFormat === "Table" ? "active" : ""
                      }
                      onClick={() => {
                        this.handleDataFormat("Table");
                      }}
                    >
                      Table <Icon icon="octicon:table-24" />
                    </li>
                    <li
                      className={
                        this.state.dataFormat === "Bar" ? "active" : ""
                      }
                      onClick={() => {
                        this.handleDataFormat("Bar");
                      }}
                    >
                      Bar <Icon icon="bi:bar-chart-fill" />
                    </li>
                    {/* <li>
                      Line <Icon icon="gridicons:line-graph" />
                    </li>
                    <li>
                      Pie Chart <Icon icon="raphael:piechart" />
                    </li>
                    <li>
                      Combo Chart <Icon icon="carbon:chart-combo" />
                    </li>
                    <li>
                      Hierachy <Icon icon="icon-park-solid:connection-point" />
                    </li> */}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2" className="position-relative">
                <Accordion.Header>Values</Accordion.Header>
                <Accordion.Body>
                  <ul
                    style={{ minHeight: "60vh" }}
                    className="p-0 m-0 valuesDrageedItem d-block"
                    onDrop={this.handleOnDropValue}
                    onDragOver={this.handleDragOver}
                  >
                    {this.state.valueWidgets.length > 0 ? null : (
                      <li>Drag and Drop Here</li>
                    )}
                    {this.state.valueWidgets.map((val, index) => {
                      return (
                        <Dropdown key={index}>
                          <Dropdown.Toggle variant="success">
                            {val.aggregate} ({val.display_name})
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {this.state.aggregateropDownValues.map(
                              (result, agrregateIndex) => {
                                return (
                                  <Dropdown.Item
                                    key={agrregateIndex}
                                    onClick={() => {
                                      result.name === "delete"
                                        ? this.handleValueDelete(
                                            val.column_name,
                                            val.display_name
                                          )
                                        : this.handleDropdownChange(
                                            result.name,
                                            index
                                          );
                                    }}
                                  >
                                    {result.label}
                                  </Dropdown.Item>
                                );
                              }
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      );
                    })}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>

        <Modal
          show={this.state.modalShowColumn}
          onHide={this.handleModalCloseCol}
        >
          <Modal.Header closeButton>
            {/* <Modal.Title>Modal heading</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            {this.state.currentColumnType === "date" ? (
              <>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.columnTypeDateDataCol}
                  value={this.state.selectedColumnTypeDateDataCol}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedColumnTypeDateDataCol"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                />
                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="checkbox"
                      id="excludeCheckbox"
                      checked={this.state.excludeNullEmptyCol}
                      onChange={this.toggleExcludeNullEmptyCol}
                    />
                    <label htmlFor="excludeCheckbox">Exclude Null/Empty:</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="yearly"
                      name="yearlyQuarterlyCheckBox"
                      checked={this.state.yearlyOrQuarterlyCol === "y"}
                      onChange={() => {
                        this.handleRadioChangeCol("y");
                      }}
                    />
                    <label htmlFor="yearly">Yearly</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="quarterly"
                      name="yearlyQuarterlyCheckBox"
                      checked={this.state.yearlyOrQuarterlyCol === "q"}
                      onChange={() => {
                        this.handleRadioChangeCol("q");
                      }}
                    />
                    <label htmlFor="quarterly">Quarterly</label>
                  </div>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.updateTableDataForDateCol}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </>
            ) : this.state.currentColumnType === "string" &&
              this.state.currentColumnSearchable === false ? (
              <div>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.stringNotSearchableDataCol}
                  value={this.state.selectedStringNotSearchableDataCol}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedStringNotSearchableDataCol"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                />
                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="checkbox"
                      id="excludeCheckbox"
                      checked={this.state.excludeNullEmptyCol}
                      onChange={this.toggleExcludeNullEmptyCol}
                    />
                    <label htmlFor="excludeCheckbox">Exclude Null/Empty:</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="exclude"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedCol === true ? true : false
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedCol: true });
                      }}
                    />
                    <label htmlFor="exclude">Include Selected</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="include"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedCol === true ? false : true
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedCol: false });
                      }}
                    />
                    <label htmlFor="include">Exclude Selected</label>
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.updateTableDataForNonSearchStringCol}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : ["number", "decimal1", "decimal2", "decimal4"].includes(
                this.state.currentColumnType
              ) ? (
              <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <b>Min</b>
                  <b>Max</b>
                </div>
                <RangeSlider
                  value={[
                    this.state.currentSelectedMinMaxColumnValue[0],
                    this.state.currentSelectedMinMaxColumnValue[1],
                  ]}
                  min={this.state.minValueColumn}
                  max={this.state.maxValueColumn}
                  progress={true}
                  onChange={(values) => {
                    // console.log("Hello", values);
                    // // console.log(values, "values");

                    this.setState({
                      minValueTextColumn: values[0],
                      maxValueTextColumn: values[1],
                      currentSelectedMinMaxColumnValue: values,
                    });
                  }}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <b>{this.state.minValueTextColumn}</b>
                  <b>{this.state.maxValueTextColumn}</b>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.updateMinMaxDataColumn}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : this.state.currentColumnType === "string" &&
              this.state.currentColumnSearchable === true ? (
              <div>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.stringSearchableDataColumn}
                  value={this.state.selectedStringSearchableDataCol}
                  // onChange={this.handleSelectChange}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedStringSearchableDataCol"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                  onInputChange={(e) => {
                    this.setState({ searchingData: e }, () => {
                      this.fetchFilterDataOnSearchColumn();
                    });
                  }}
                  onclick={() => {
                    this.fetchFilterDataOnSearchColumn();
                  }}
                />

                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="checkbox"
                      id="excludeCheckbox"
                      checked={this.state.excludeNullEmptyCol}
                      onChange={this.toggleExcludeNullEmptyCol}
                    />
                    <label htmlFor="excludeCheckbox">Exclude Null/Empty:</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="exclude"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedCol === true ? true : false
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedCol: true });
                      }}
                    />
                    <label htmlFor="exclude">Include Selected</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="include"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedCol === true ? false : true
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedCol: false });
                      }}
                    />
                    <label htmlFor="include">Exclude Selected</label>
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.selectedStringSearchableDataColBtn}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
        </Modal>

        <Modal show={this.state.modalShowRow} onHide={this.handleModalCloseRow}>
          <Modal.Header closeButton>
            {/* <Modal.Title>Modal heading</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            {this.state.currentRowType === "date" ? (
              <>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.columnTypeDateDataRow}
                  value={this.state.selectedColumnTypeDateDataRow}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedColumnTypeDateDataRow"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                />
                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="checkbox"
                      id="excludeCheckbox"
                      checked={this.state.excludeNullEmptyRow}
                      onChange={this.toggleExcludeNullEmptyRow}
                    />
                    <label htmlFor="excludeCheckbox">Exclude Null/Empty:</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="yearly"
                      name="yearlyQuarterlyCheckBox"
                      checked={this.state.yearlyOrQuarterlyRow === "y"}
                      onChange={() => {
                        this.handleRadioChangeRow("y");
                      }}
                    />
                    <label htmlFor="yearly">Yearly</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="quarterly"
                      name="yearlyQuarterlyCheckBox"
                      checked={this.state.yearlyOrQuarterlyRow === "q"}
                      onChange={() => {
                        this.handleRadioChangeRow("q");
                      }}
                    />
                    <label htmlFor="quarterly">Quarterly</label>
                  </div>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.updateTableDataForDateRow}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </>
            ) : this.state.currentRowType === "string" &&
              this.state.currentRowSearchable === false ? (
              <div>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.stringNotSearchableDataRow}
                  value={this.state.selectedStringNotSearchableDataRow}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedStringNotSearchableDataRow"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                />
                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="checkbox"
                      id="excludeCheckbox"
                      checked={this.state.excludeNullEmptyRow}
                      onChange={this.toggleExcludeNullEmptyRow}
                    />
                    <label htmlFor="excludeCheckbox">Exclude Null/Empty:</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="exclude"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedRow === true ? true : false
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedRow: true });
                      }}
                    />
                    <label htmlFor="exclude">Include Selected</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="include"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedRow === true ? false : true
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedRow: false });
                      }}
                    />
                    <label htmlFor="include">Exclude Selected</label>
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.updateTableDataForNonSearchStringRow}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : ["number", "decimal1", "decimal2", "decimal4"].includes(
                this.state.currentRowType
              ) ? (
              <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <b>Min</b>
                  <b>Max</b>
                </div>
                <RangeSlider
                  value={[
                    this.state.currentSelectedMinMaxRowValue[0],
                    this.state.currentSelectedMinMaxRowValue[1],
                  ]}
                  min={this.state.minValueRow}
                  max={this.state.maxValueRow}
                  progress={true}
                  onChange={(values) => {
                    // console.log("Hello", values);
                    // // console.log(values, "values");

                    this.setState({
                      minValueTextRow: values[0],
                      maxValueTextRow: values[1],
                      currentSelectedMinMaxRowValue: values,
                    });
                  }}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <b>{this.state.minValueTextRow}</b>
                  <b>{this.state.maxValueTextRow}</b>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.updateMinMaxDataRow}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : this.state.currentRowType === "string" &&
              this.state.currentRowSearchable === true ? (
              <div>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.stringSearchableDataRow}
                  value={this.state.selectedStringSearchableDataRow}
                  // onChange={this.handleSelectChange}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedStringSearchableDataRow"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                  onInputChange={(e) => {
                    this.setState({ searchingData: e }, () => {
                      this.fetchFilterDataOnSearchRow();
                    });
                  }}
                  onclick={() => {
                    this.fetchFilterDataOnSearchRow();
                  }}
                />

                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="checkbox"
                      id="excludeCheckbox"
                      checked={this.state.excludeNullEmptyRow}
                      onChange={this.toggleExcludeNullEmptyRow}
                    />
                    <label htmlFor="excludeCheckbox">Exclude Null/Empty:</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="exclude"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedRow === true ? true : false
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedRow: true });
                      }}
                    />
                    <label htmlFor="exclude">Include Selected</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="include"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedRow === true ? false : true
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedRow: false });
                      }}
                    />
                    <label htmlFor="include">Exclude Selected</label>
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.updateTableDataRow}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.modalShowFilter}
          onHide={this.handleModalCloseFilter}
        >
          <Modal.Header closeButton>
            {/* <Modal.Title>Modal heading</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            {this.state.currentFilterType === "date" ? (
              <>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.filterSectionDate}
                  value={this.state.selectedFilterSectionDate}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedFilterSectionDate"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                />
                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="radio"
                      id="yearly"
                      name="yearlyQuarterlyCheckBox"
                      checked={this.state.yearlyOrQuarterlyFilter === "y"}
                      onChange={() => {
                        this.handleRadioChangeFilter("y");
                      }}
                    />
                    <label htmlFor="yearly">Yearly</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="quarterly"
                      name="yearlyQuarterlyCheckBox"
                      checked={this.state.yearlyOrQuarterlyFilter === "q"}
                      onChange={() => {
                        this.handleRadioChangeFilter("q");
                      }}
                    />
                    <label htmlFor="quarterly">Quarterly</label>
                  </div>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.filterSectionDateBtn}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </>
            ) : this.state.currentFilterType === "string" &&
              this.state.currentFilterSearchable === false ? (
              <div>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.filterSectionNotSearchable}
                  value={this.state.selectedFilterSectionNotSearchable}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedFilterSectionNotSearchable"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                />
                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="radio"
                      id="exclude"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedFilter === true ? true : false
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedFilter: true });
                      }}
                    />
                    <label htmlFor="exclude">Include Selected</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="include"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedFilter === true ? false : true
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedFilter: false });
                      }}
                    />
                    <label htmlFor="include">Exclude Selected</label>
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.filterSectionNotSearchableBtn}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : ["number", "decimal1", "decimal2", "decimal4"].includes(
                this.state.currentFilterType
              ) ? (
              <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <b>Min</b>
                  <b>Max</b>
                </div>
                <RangeSlider
                  value={[
                    this.state.currentSelectedMinMaxFilterValue[0],
                    this.state.currentSelectedMinMaxFilterValue[1],
                  ]}
                  min={this.state.minValueFilter}
                  max={this.state.maxValueFilter}
                  progress={true}
                  onChange={(values) => {
                    // console.log("Hello", values);
                    this.setState({
                      minValueTextFilter: values[0],
                      maxValueTextFilter: values[1],
                      currentSelectedMinMaxFilterValue: values,
                    });
                  }}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <b>{this.state.minValueTextFilter}</b>
                  <b>{this.state.maxValueTextFilter}</b>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.minMaxValueFilterBtn}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : this.state.currentFilterType === "string" &&
              this.state.currentFilterSearchable === true ? (
              <div>
                <Select
                  isMulti
                  name="colors"
                  options={this.state.filterSectionSearchable}
                  value={this.state.selectedFilterSectionSearchable}
                  onChange={(selectedOptions) =>
                    this.handleSelectChange(
                      selectedOptions,
                      "selectedFilterSectionSearchable"
                    )
                  }
                  className="reactSelectCss"
                  classNamePrefix="reactSelectCssInner"
                  onInputChange={(e) => {
                    this.setState({ searchingData: e }, () => {
                      this.fetchFilterDataOnSearchFilter();
                    });
                  }}
                  onclick={() => {
                    this.fetchFilterDataOnSearchFilter();
                  }}
                />

                <div className="d-flex align-items-center excludeIncludeCheckBox mt-2">
                  <div>
                    <input
                      type="radio"
                      id="exclude"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedFilter === true ? true : false
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedFilter: true });
                      }}
                    />
                    <label htmlFor="exclude">Include Selected</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="include"
                      name="excludeIncludeCheckBox"
                      checked={
                        this.state.popupIsIncludedFilter === true ? false : true
                      }
                      onChange={() => {
                        this.setState({ popupIsIncludedFilter: false });
                      }}
                    />
                    <label htmlFor="include">Exclude Selected</label>
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    onClick={this.selectedFilterSectionSearchableBtn}
                    class="btn btn-secondary mt-3"
                  >
                    Get Data
                  </button>
                </div>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps)(MakeYourOwnChart);
